import { assignTrainings } from 'api/training';
import { debounceRole } from 'utils/debounces';

import type { FormType } from '..';

export const roleTrainingForm: FormType = {
  createFn: assignTrainings,
  submitText: 'Atribuir Treinamento',
  cancelText: 'Cancelar',
  successText: 'Treinamento atribuido com sucesso!',
  fields: [
    [{
      name: 'roles',
      type: 'select',
      required: true,
      isMultiple: true,
      props: {
        placeholder: 'Buscar',
        label: 'Tipo de permissão',
        loadOptions: debounceRole,
      },
    }],
  ],
};
